// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".message-history-family-list .key-name[data-v-3c46434c]{font-weight:700;font-size:1rem;margin-right:.5rem}.message-history-family-list .family[data-v-3c46434c]{border-bottom:1px solid #9b9b9b}.message-history-family-list .family[data-v-3c46434c]:last-child{border-bottom:0}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
